<template>
  <div class="page-online">
    <section class="section-shaped my-0">
      <div class="shape shape-style-1 shape-default alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div class="container shape-container">
        <div class="row">
          <div class="col-lg-6 d-flex flex-column justify-content-center">
            <h2 class="display-3 text-white">Online platform</h2>
            <p class="lead text-white">
              A solution for a full cycle of online sales, from cost calculation to online payment and notification of&nbsp;policyholder.
            </p>
          </div>
          <div class="col-lg-6 text-right">
            <img v-lazy="'img/theme/mobile.png'" class="img-fluid">
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="card bg-default shadow border-0">
              <img v-lazy="'img/theme/img-2-1200x1000.jpg'" class="card-img-top">
              <blockquote class="card-blockquote">
                <svg
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 583 95"
                    class="svg-bg"
                >
                  <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                  <polygon
                      points="0,42 583,95 683,0 0,95"
                      opacity=".2"
                      class="fill-default"
                  ></polygon>
                </svg>
                <h4 class="display-3 font-weight-bold text-white">24 / 7</h4>
                <p
                    class="lead text-italic text-white"
                >Online sales is an agent that works around the clock, seven days a week and holidays.</p>
              </blockquote>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5">
              <icon
                  name="ni ni-basket"
                  class="mb-5"
                  size="lg"
                  type="primary"
                  shadow
                  rounded
              ></icon>

              <h3>Fast, easy and convenient</h3>
              <p>Just a few minutes and your insurance products are available around the clock anywhere in the world to
                millions of potential customers.</p>
              <p>All policies go to
                <router-link to="/for-agents">agent's office</router-link>
                .
              </p>

              <ul class="list-unstyled mt-5 mb-5">
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="badge badge-circle badge-primary mr-3">
                        <i class="ni ni-settings"></i>
                      </div>
                    </div>
                    <div>
                      <h5 class="mb-0">Individual conditions</h5>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="badge badge-circle badge-primary mr-3">
                        <i class="ni ni-credit-card"></i>
                      </div>
                    </div>
                    <div>
                      <h5 class="mb-0">Payment gateways</h5>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="badge badge-circle badge-primary mr-3">
                        <i class="ni ni-chat-round"></i>
                      </div>
                    </div>
                    <div>
                      <h5 class="mb-0">SMS notifications</h5>
                    </div>
                  </div>
                </li>
                <li class="py-2">
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="badge badge-circle badge-primary mr-3">
                        <i class="ni ni-email-83"></i>
                      </div>
                    </div>
                    <div>
                      <h5 class="mb-0">Email notifications</h5>
                    </div>
                  </div>
                </li>
              </ul>

              <p>
                <router-link to="/contacts" class="btn btn-primary">Contact us</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {};
</script>
<style>
</style>
